import React, { useState } from "react";
import {
    Paper,
    Grid,
    Typography,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    FormControl,
    Select,
    MenuItem,
    IconButton
} from "@mui/material";
import { useHistory } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import { createProcessRequest, getProcessRequest } from "../../globalhelper/helper";

const CreateTheme = () => {

    const history = useHistory();

    // Form State
    const [formData, setFormData] = useState({
        productcode: "DTFOWS",
        processcode: "",
        themename: "",
        targetfieldname: ""
    });


    const [tableData, setTableData] = useState([]);

    const dataTypes = [
        "VARCHAR",
        "FLOAT",
        "INTEGER",
        "DATE",
        "DATETIME",
        "BOOLEAN"
    ];

    const dropdownOptions = [
        "null",
        "True"
    ];


    const handleChange = (event) => {

        const { name, value } = event.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };


const handleRowChange = (
    index,
    field,
    value
) => {

    const updatedRows = [...tableData];

    updatedRows[index][field] = value;

    setTableData(updatedRows);

};

    // Delete Row
    const handleDelete = (index) => {

        const updated =
            tableData.filter(
                (_, i) => i !== index
            );

        setTableData(updated);
    };


const getDuplicateTargetFields = () => {

    const values = tableData.map(row =>
        row.targetfieldname?.trim()
    );

    return values.filter(
        (item, index) =>
            item &&
            values.indexOf(item) !== index
    );

};


const hasError = tableData.some(
    row => !row.targetfieldname?.trim()
);


const handleGenerate = async () => {

    if (!formData.productcode.trim()) {

        toast.error("Product Code is required");

        return;
    }

    if (!formData.processcode.trim()) {

        toast.error("Process Code is required");

        return;
    }

    if (!formData.themename.trim()) {

        toast.error("Theme Name is required");

        return;
    }

    if (!formData.targetfieldname.trim()) {

        toast.error("Target Field Name is required");

        return;
    }

    try {

        const response =
            await getProcessRequest(
                `api/theme/getThemeByProcess/${formData.processcode}`
            );

        console.log("THEME LIST:", response);

        const existingTheme =
            response?.data?.data?.find(
                (item) =>
                    item.productcode?.toLowerCase() ===
                    formData.productcode?.toLowerCase() &&
                    item.processcode?.toLowerCase() ===
                    formData.processcode?.toLowerCase() &&
                    item.themename?.toLowerCase() ===
                    formData.themename?.toLowerCase()
            );

        if (existingTheme) {

            toast.error(
                `Theme "${formData.themename}" already exists for Process Code "${formData.processcode}"`
            );

            return;
        }

        const targetFieldList =
            formData.targetfieldname
                .split(/\r?\n|\s+/)
                .map(item => item.trim())
                .filter(item => item !== "");

        const generatedRows =
            targetFieldList.map((targetField) => ({

                productcode:
                    formData.productcode,

                processcode:
                    formData.processcode,

                themename:
                    formData.themename,

                targetfieldname:
                    targetField,

                createddate:
                    "",

                targetfielddatatype:
                    "VARCHAR",

                lde:
                    "",

                sourcefieldname:
                    "",

                mandatory:
                    "No",

                sourcefieldfunction:
                    "",

                dataformat:
                    "",

                scdp:
                    false

            }));

        setTableData((prev) => [
            ...prev,
            ...generatedRows
        ]);

        setFormData((prev) => ({
            ...prev,
            targetfieldname: ""
        }));

        toast.success(
            "Rows generated successfully"
        );

    } catch (error) {

        console.log(error);

        toast.error(
            "Failed to validate Theme"
        );

    }

};

const handleAddRow = () => {

    if (!formData.productcode.trim()) {

        toast.error("Product Code is required");

        return;
    }

    if (!formData.processcode.trim()) {

        toast.error("Process Code is required");

        return;
    }

    if (!formData.themename.trim()) {

        toast.error("Theme Name is required");

        return;
    }

    const newRow = {

        productcode:
            formData.productcode,

        processcode:
            formData.processcode,

        themename:
            formData.themename,

        targetfieldname:
            "",

        createddate:
            "",

        targetfielddatatype:
            "VARCHAR",

        lde:
            "",

        sourcefieldname:
            "",

        mandatory:
            "No",

        sourcefieldfunction:
            "",

        dataformat:
            "",

        scdp:
            false

    };

    setTableData((prev) => [
        ...prev,
        newRow
    ]);

};

    // Save All
const handleSaveAll = async () => {

    const hasEmpty = tableData.some(
        (row) => !row.targetfieldname?.trim()
    );

    if (hasEmpty) {

        toast.error(
            "Target Field Name is required"
        );

        return;
    }

    const duplicates =
        getDuplicateTargetFields();

    if (duplicates.length > 0) {

        const uniqueDuplicates = [
            ...new Set(duplicates)
        ];

        toast.error(
            `Duplicate Target Field Name: ${uniqueDuplicates.join(", ")}`
        );

        return;
    }

    console.log(
        "FINAL PAYLOAD:",
        tableData
    );

    try {

        const result =
            await createProcessRequest(
                "api/theme/createBulkTheme",
                tableData
            );

        console.log(
            "SAVE RESULT:",
            result
        );

        if (!result?.data?.success) {

            toast.error(
                result?.data?.message ||
                "Failed to create Theme"
            );

            return;
        }

        toast.success(
            result?.data?.message ||
            "Theme Created Successfully"
        );

        setTableData([]);

        setFormData({

            productcode:
                "DTFOWS",

            processcode:
                "",

            themename:
                "",

            targetfieldname:
                ""

        });

    } catch (error) {

        console.log(
            "SAVE ERROR:",
            error
        );

        toast.error(
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            "Failed to create Theme"
        );

    }

};

    return (

        <Paper
            elevation={3}
            sx={{
                padding: "25px",
                margin: "20px"
            }}
        >

            {/* Header */}
            <Grid
                container
                justifyContent="space-between"
                alignItems="center"
                sx={{ marginBottom: "25px" }}
            >

                <Grid item>
                    <Typography variant="h5">
                        Create Theme
                    </Typography>
                </Grid>

                <Grid item>

                    <Button
                        variant="outlined"
                        onClick={() => history.push("/theme-list")}
                    >
                        Back
                    </Button>

                </Grid>

            </Grid>

{/* Form Section */}

<Paper
    elevation={2}
    sx={{
        padding: "20px",
        marginBottom: "25px"
    }}
>

    <Grid container spacing={3}>

        {/* Product Code */}
        <Grid item xs={12} md={4}>

            <TextField
                fullWidth
                label="Product Code"
                name="productcode"
                value={formData.productcode}
                onChange={handleChange}
            />

        </Grid>

        {/* Process Code */}
        <Grid item xs={12} md={4}>

            <TextField
                fullWidth
                label="Process Code"
                name="processcode"
                value={formData.processcode}
                onChange={handleChange}
            />

        </Grid>

        {/* Theme Name */}
        <Grid item xs={12} md={4}>

            <TextField
                fullWidth
                label="Theme Name"
                name="themename"
                value={formData.themename}
                onChange={handleChange}
            />

        </Grid>

        {/* Target Field Name */}
        <Grid item xs={12}>

            <TextField
                fullWidth
                multiline
                rows={8}
                label="Target Field Name"
                name="targetfieldname"
                value={formData.targetfieldname}
                onChange={handleChange}
                helperText="Paste one Target Field Name per line or space separated"
            />

        </Grid>

        {/* Generate Button */}
        <Grid item xs={12}>

            <Button
                variant="contained"
                onClick={handleGenerate}
            >
                Generate Rows
            </Button>

        </Grid>

    </Grid>

</Paper>

            {/* Table Section */}

            {tableData.length > 0 && (

                <Paper elevation={2}>

                    <div
                        style={{
                            width: "100%",
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "500px"
                        }}
                    >

                        <TableContainer>

                            <Table
                                stickyHeader
                                sx={{
                                    minWidth: "1800px"
                                }}
                            >

<TableHead>

    <TableRow>

        <TableCell>
            Product Code
        </TableCell>

        <TableCell>
            Process Code
        </TableCell>

        <TableCell>
            Theme Name
        </TableCell>

        <TableCell>
            Target Field Name
        </TableCell>

        <TableCell>
            Target Field Data Type
        </TableCell>

        <TableCell>
            LDE
        </TableCell>

        <TableCell>
            Source Field Name
        </TableCell>

        <TableCell>
            Mandatory
        </TableCell>

        <TableCell>
            Source Field Function
        </TableCell>

        <TableCell>
            Data Format
        </TableCell>

        <TableCell>
            SCDP
        </TableCell>

        <TableCell>
            Action
        </TableCell>

    </TableRow>

</TableHead>

                                <TableBody>

                                    {tableData.map((row, index) => (

    <TableRow key={index}>

        {/* Product Code */}
        <TableCell>
            {row.productcode}
        </TableCell>

        {/* Process Code */}
        <TableCell>
            {row.processcode}
        </TableCell>

        {/* Theme Name */}
        <TableCell>
            {row.themename}
        </TableCell>

        {/* Target Field Name */}
        <TableCell>

            <TextField
                value={row.targetfieldname}
                error={!row.targetfieldname?.trim()}
                helperText={
                    !row.targetfieldname?.trim()
                        ? "Target Field Name is required"
                        : ""
                }
                onChange={(e) =>
                    handleRowChange(
                        index,
                        "targetfieldname",
                        e.target.value
                    )
                }
                size="small"
                sx={{
                    minWidth: "180px"
                }}
            />

        </TableCell>

        {/* Target Field Data Type */}
        <TableCell>

            <FormControl
                size="small"
                sx={{ minWidth: "150px" }}
            >

                <Select
                    value={row.targetfielddatatype}
                    onChange={(e) =>
                        handleRowChange(
                            index,
                            "targetfielddatatype",
                            e.target.value
                        )
                    }
                >

                    {dataTypes.map((item) => (

                        <MenuItem
                            key={item}
                            value={item}
                        >
                            {item}
                        </MenuItem>

                    ))}

                </Select>

            </FormControl>

        </TableCell>

        {/* LDE */}
        <TableCell>

            <TextField
                value={row.lde}
                onChange={(e) =>
                    handleRowChange(
                        index,
                        "lde",
                        e.target.value
                    )
                }
                size="small"
                sx={{ width: "100px" }}
            />

        </TableCell>

        {/* Source Field Name */}
        <TableCell>

            <TextField
                value={row.sourcefieldname}
                onChange={(e) =>
                    handleRowChange(
                        index,
                        "sourcefieldname",
                        e.target.value
                    )
                }
                size="small"
                sx={{ minWidth: "180px" }}
            />

        </TableCell>

        {/* Mandatory */}
        <TableCell>

            <FormControl
                size="small"
                sx={{ minWidth: "120px" }}
            >

                <Select
                    value={row.mandatory}
                    onChange={(e) =>
                        handleRowChange(
                            index,
                            "mandatory",
                            e.target.value
                        )
                    }
                >

                    <MenuItem value="Yes">
                        Yes
                    </MenuItem>

                    <MenuItem value="No">
                        No
                    </MenuItem>

                </Select>

            </FormControl>

        </TableCell>

        {/* Source Field Function */}
        <TableCell>

            <TextField
                value={row.sourcefieldfunction}
                onChange={(e) =>
                    handleRowChange(
                        index,
                        "sourcefieldfunction",
                        e.target.value
                    )
                }
                size="small"
                sx={{ minWidth: "180px" }}
            />

        </TableCell>

        {/* Data Format */}
        <TableCell>

            <TextField
                value={row.dataformat}
                onChange={(e) =>
                    handleRowChange(
                        index,
                        "dataformat",
                        e.target.value
                    )
                }
                size="small"
                sx={{ minWidth: "140px" }}
            />

        </TableCell>

        {/* SCDP */}
        <TableCell>

            <FormControl
                size="small"
                sx={{ minWidth: "100px" }}
            >

                <Select
                    value={String(row.scdp)}
                    onChange={(e) =>
                        handleRowChange(
                            index,
                            "scdp",
                            e.target.value === "true"
                        )
                    }
                >

                    <MenuItem value="true">
                        True
                    </MenuItem>

                    <MenuItem value="false">
                        False
                    </MenuItem>

                </Select>

            </FormControl>

        </TableCell>
                                            

                                            {/* Action */}
                                            <TableCell>

                                                <IconButton
                                                    color="error"
                                                    onClick={() =>
                                                        handleDelete(index)
                                                    }
                                                >
                                                    <DeleteIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>

                                    ))}

                                </TableBody>

                            </Table>

                        </TableContainer>

                    </div>

                    {/* Footer Buttons */}
                    <Grid
                        container
                        justifyContent="flex-end"
                        spacing={2}
                        sx={{ padding: "20px" }}
                    >

                        <Grid item>
                            <Button
                                variant="outlined"
                                onClick={handleAddRow}
                            >
                                + Add Row
                            </Button>
                        </Grid>

                        <Grid item>

                            <Button
                                variant="contained"
                                color="success"
                                disabled={hasError}
                                onClick={handleSaveAll}
                            >
                                Save All
                            </Button>

                        </Grid>

                    </Grid>

                </Paper>

            )}

        </Paper>
    );
};

export default CreateTheme;
